import { getApiBase, safeJson, unwrapArray } from "./http";
import type { EventLite, FunctionLite } from "../types";

export const fetchEventsApi = async (): Promise<EventLite[]> => {
    const base = getApiBase();
    const res = await fetch(`${base}/api/events`);
    if (!res.ok) return [];

    const data = await safeJson<any>(res);
    const arr = unwrapArray(data);

    return arr
        .map((e: any) => ({
            eventID: Number(e.eventID ?? e.EventID ?? e.id ?? e.ID),
            eventName: String(
                e.eventName ??
                e.EventName ??
                e.title ??
                e.Title ??
                `Event #${e.eventID ?? e.EventID ?? "?"}`
            ),
        }))
        .filter((e: EventLite) => Number.isFinite(e.eventID) && e.eventID > 0);
};

export const fetchFunctionsApi = async (
    eventId: number
): Promise<FunctionLite[]> => {
    const base = getApiBase();
    const res = await fetch(`${base}/api/events/${eventId}/functions`);
    if (!res.ok) return [];

    const data = await safeJson<any>(res);
    const arr = unwrapArray(data);

    return arr
        .map((f: any) => ({
            functionId: Number(f.functionId),
            functionName: String(f.functionName),
        }))
        .filter((x: FunctionLite) => Number.isFinite(x.functionId) && x.functionId > 0);
};